export * from './app.config'



// WEBPACK FOOTER //
// ./src/_config/index.js